function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    plus\n  ");

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 3.74,
  y1: 20,
  x2: 20,
  y2: 20,
  fill: "none",
  stroke: "#727475",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 36.27,
  y1: 20,
  x2: 20,
  y2: 20,
  fill: "none",
  stroke: "#727475",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 20,
  y1: 36.26,
  x2: 20,
  y2: 20,
  fill: "none",
  stroke: "#727475",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 20,
  y1: 3.74,
  x2: 20,
  y2: 20,
  fill: "none",
  stroke: "#727475",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
});

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgPlus;